/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type ICarrierTrailerFragment = { __typename?: 'Trailer' } & Pick<
  Types.ITrailer,
  'id' | 'number' | 'note' | 'state' | 'updatedAt' | 'arrivedAt'
> & {
    carrier: { __typename?: 'CarrierApplication' } & Pick<
      Types.ICarrierApplication,
      'id' | 'dotNumber' | 'mcNumber' | 'name' | 'state' | 'fmcsaRating' | 'isTrusted'
    >
    shipperFacility?: Types.Maybe<
      { __typename?: 'ShipperFacility' } & Pick<Types.IShipperFacility, 'id' | 'uuid'> & {
          facility: { __typename?: 'Facility' } & Pick<Types.IFacility, 'uuid' | 'id' | 'name'> & {
              location: { __typename?: 'Location' } & Pick<
                Types.ILocation,
                'id' | 'stateCode' | 'city'
              >
            }
        }
    >
    shipment?: Types.Maybe<
      { __typename?: 'Shipment' } & Pick<
        Types.IShipment,
        'id' | 'state' | 'hasClaims' | 'shipperRateType' | 'currentStopIndex' | 'updatedAt'
      > & {
          characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
            Types.IShipmentCharacteristics,
            | 'hazmat'
            | 'hot'
            | 'mustGo'
            | 'backhaulEligible'
            | 'rolloverCount'
            | 'sameDaySpot'
            | 'bounceCount'
          >
          firstPickup: { __typename?: 'ShipmentStop' } & Pick<
            Types.IShipmentStop,
            'id' | 'city' | 'stateCode' | 'dropTrailer'
          >
          lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
            Types.IShipmentStop,
            'id' | 'city' | 'stateCode' | 'dropTrailer'
          >
          stops: Array<
            { __typename?: 'ShipmentStop' } & Pick<
              Types.IShipmentStop,
              'id' | 'arrivedAt' | 'stopSequence' | 'stopType'
            > & {
                appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                  Types.IShipmentStopAppointment,
                  'id' | 'status' | 'startAt' | 'endAt' | 'timezone'
                >
              }
          >
          equipment: { __typename?: 'Equipment' } & Pick<
            Types.IEquipment,
            'id' | 'name' | 'parentKey'
          >
          shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
            Types.IShipperApplication,
            'id' | 'name'
          >
        }
    >
  }

export const CarrierTrailerFragmentDoc = gql`
  fragment CarrierTrailer on Trailer {
    id
    number
    carrier {
      id
      dotNumber
      mcNumber
      name
      state
      fmcsaRating
      isTrusted
    }
    shipperFacility {
      id
      uuid
      facility {
        uuid
        id
        name
        location {
          id
          stateCode
          city
        }
      }
    }
    shipment {
      id
      state
      hasClaims
      shipperRateType
      currentStopIndex
      updatedAt
      characteristics {
        hazmat
        hot
        mustGo
        backhaulEligible
        rolloverCount
        sameDaySpot
        bounceCount
      }
      firstPickup {
        id
        city
        stateCode
        dropTrailer
      }
      lastDelivery {
        id
        city
        stateCode
        dropTrailer
      }
      stops {
        id
        arrivedAt
        stopSequence
        stopType
        appointment {
          id
          status
          startAt
          endAt
          timezone
        }
      }
      equipment {
        id
        name
        parentKey
      }
      shipperApplication {
        id
        name
      }
    }
    note
    state
    updatedAt
    arrivedAt
  }
`
